import type { RouteLocationNormalized, RouteMeta, RouteRecordRaw, RouteRecordRedirect, RouteRecordSingleViewWithChildren } from 'vue-router'
//import type { NavigationOptions } from '@azure/msal-browser'
//import type { Router } from 'vue-router'

export type PropsType = boolean | Record<string, any> | ((to: RouteLocationNormalized) => Record<string, any>);

/**
 * Create component route
 */
export function anonRoute(name: string, path: string, view: string): RouteRecordRaw
export function anonRoute(name: string, path: string, view: string, meta?: RouteMeta, children?: RouteRecordRaw[]): RouteRecordRaw;
export function anonRoute(name: string, path: string, view: string, meta?: RouteMeta, children?: RouteRecordRaw[], props?: PropsType): RouteRecordRaw;
export function anonRoute(name: string, path: string, view: string, meta?: RouteMeta, children?: RouteRecordRaw[], props?: PropsType): RouteRecordRaw {
   return {
      name,
      path,
      component: () => getView(view),
      meta,
      props: props ?? true,
      children,
   }
}

/**
 * Create component route that requires to be authenticated
 */
export function route(name: string, path: string, view: string): RouteRecordRaw
export function route(name: string, path: string, view: string, meta?: RouteMeta): RouteRecordRaw;
export function route(name: string, path: string, view: string, meta?: RouteMeta, children?: RouteRecordRaw[]): RouteRecordRaw;
export function route(name: string, path: string, view: string, meta?: RouteMeta, children?: RouteRecordRaw[], props?: PropsType): RouteRecordRaw;
export function route(name: string, path: string, view: string, meta?: RouteMeta, children?: RouteRecordRaw[], props?: PropsType): RouteRecordRaw {
   const m: RouteMeta = meta ?? {};
   m.requiresAuth = m.requiresAuth !== undefined ? m.requiresAuth : true;
   return {
      name,
      path,
      component: () => getView(view), //import(`../views/${view}.vue`),
      meta: m,
      props: props ?? true,
      children,
   }
}
/**
 * Create component route that redirects to a named route
 */
export function redirectRoute(name: string, path: string, redirectRouteName: string, children?: RouteRecordRaw[]): RouteRecordRedirect {
   return {
      name,
      path,
      redirect: {
         name: redirectRouteName,
      },
      children,
   }
}

/**
 * Create component route that redirects to a named route
 */
export function parentRoute(name: string, path: string, children: RouteRecordRaw[]): RouteRecordSingleViewWithChildren {
   return {
      name,
      path,
      children,
   }
}

/**
 * Create hook route
 */
export function hook(path: string, callback: () => Promise<any>): RouteRecordRaw {
   return {
      path,
      component: { render: () => null },
      beforeEnter: async (to, from, next) => {
         const result = await callback();
         result
            ? next()
            : next(false)
      }
   }
}

async function getView(view: string) {
   const comps = import.meta.glob<any>("../views/**/*.vue");
   const match = comps[`../views/${view}.vue`];
   //For TS: const match: () => Promise<any> = comps[`../views/${view}.vue`];
   if (!match)
      throw new Error(`Could not find view /views/${view}.vue`);
   
   return (await match()).default;
}
